import styled from 'styled-components';
import { Typography } from '@mui/material';

import colors from '../../../styles/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  row-gap: 10px;
`;

const StyledAudio = styled.audio`
  max-width: 90%;
  width: 400px;
`;

const Title = styled(Typography)`
  margin-top: 10px;
  font-size: 12px;
  font-weight: 500;
  width: 70%;
  text-align: center;
`;

const ErrorText = styled.div`
  color: ${colors.base.warning};
  font-size: 12px;
  padding: 2px;
`;

export {
  Container,
  StyledAudio,
  Title,
  ErrorText,
};
